module.exports = __webpack_public_path__ + "img/kontakt_w.9b76acf3.svg";